export default __webpack_public_path__ + "img/bRPNPaGa.8721ce46.svg";